import CheckIcon from '@mui/icons-material/Check'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

export default function CopyRow({ label, value, primary = false }: { label: string; value: string; primary?: boolean }) {
  const intl = useIntl()
  const [copied, setCopied] = useState(false)
  const copy = () => {
    void navigator.clipboard?.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }
  const labelLc = label.toLowerCase()
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        bgcolor: 'action.hover',
        border: primary ? '1px solid' : 'none',
        borderColor: 'primary.main',
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.4 }}>
          {label}
        </Typography>
        <Typography sx={{ fontFamily: 'monospace', fontSize: 13, wordBreak: 'break-all' }}>
          {value}
        </Typography>
      </Box>
      <Tooltip title={copied ? intl.formatMessage({ id: 'caChat.identity.tooltip.copied' }) : intl.formatMessage({ id: 'caChat.identity.tooltip.copy' }, { label: labelLc })}>
        <IconButton
          aria-label={intl.formatMessage({ id: 'caChat.identity.aria.copy' }, { label: labelLc })}
          size="small"
          onClick={copy}
          color={copied ? 'success' : 'primary'}
        >
          {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
